/**
 * Escritura de supervisor_groups/{uidSupervisora} (spec
 * 2026-09-28-grupos-supervisoras). Las reglas exigen el doc completo con sus
 * cinco campos, updatedBy == quien escribe y updatedAt == hora del servidor,
 * así que siempre se hace set() completo. La validación de negocio vive en
 * lib/supervisor_groups.js#validateGroup y la hace la pantalla antes de llamar.
 */

export const supervisorGroups = {
  save: ({ sid, members, available, backupUid }) => async (dispatch, state, firebase) => {
    const user = firebase().auth().currentUser;
    await firebase().firestore().collection('supervisor_groups').doc(sid).set({
      members: [...new Set(Array.isArray(members) ? members : [])],
      available: available !== false,
      backupUid: backupUid || null,
      updatedAt: firebase().firestore.FieldValue.serverTimestamp(),
      updatedBy: user.uid,
    });
  },
};
